module.exports = __webpack_public_path__ + "static/img/illustration01.6513fde3.png";